import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Dropdown } from 'react-bootstrap';
// utils
import { handleCatchError } from 'utils/handleErrors';
// api
import { getBillingDocs } from '../../../../../api/Api-admin';

// components
import Paginate from '../../../../../components/Paginate';
import BillingRow from '../components/BillingRow';
import BillingCard from '../components/BillingCard';
import LoadingPulse from '../../../../../../components/loading/LoadingPulse';

function Reps({ crmId }) {
  const [reps, setReps] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // paginate
  const [totalPages, setTotalPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [message, setMessage] = useState('');

  // - Use references to do scroll Up
  const startRef = useRef(null);

  useEffect(() => {
    const handleGetReps = () => {
      setIsLoading(true);
      getBillingDocs('reps', crmId, currentPage, pageSize)
        .then((response) => {
          // console.log('Get reps res', response);
          if (response.data !== undefined) {
            setIsLoading(false);
            setReps(response.data);
            setTotalPages(response.total_pages);
            if (response?.data.length === 0) {
              setMessage('No hay Reps registrados.');
            }
            if (startRef.current) {
              startRef.current.scrollIntoView({ behavior: 'smooth' });
            }
          }
        })
        .catch((error) => {
          handleCatchError(error);
          setIsLoading(false);
          setMessage('Error');
          // console.log('Err catch get reps', err);
        });
    };
    handleGetReps();
  }, [currentPage, pageSize]);

  const settingPage = (limit) => {
    setIsLoading(true);
    setPageSize(limit);
    setCurrentPage(1);
  };
  return (
    <>
      {isLoading && <LoadingPulse />}
      {message ? (
        <div className="pt-5 mt-5">
          <h3 className="text-center mt-5 pt-5">
            {message}
            <img alt="box" src="/img/animation/doc.webp" style={{ width: '50px', height: '50px' }} />{' '}
          </h3>
        </div>
      ) : (
        <div ref={startRef} id="cardContainer">
          <Row>
            <Col className="mb-1 text-end">
              {/* {reps?.length > 0 && <RepsCSV reps={reps} />} */}
              <Dropdown align={{ xs: 'end' }} className={`d-inline-block ms-1 ${reps?.length < 10 && 'invisible'}`}>
                <Dropdown.Toggle variant="foreground-alternate" className="shadow sw-13">
                  {`${pageSize} Reps`}
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow dropdown-menu-end">
                  <Dropdown.Item className={`${pageSize === 10 && 'd-none'}`} onClick={() => settingPage(10)}>
                    10 Reps
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 20 && 'd-none'}`} onClick={() => settingPage(20)}>
                    20 Reps
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 50 && 'd-none'}`} onClick={() => settingPage(50)}>
                    50 Reps
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 100 && 'd-none'}`} onClick={() => settingPage(100)}>
                    100 Reps
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div className={`text-muted d-lg-none mt-3 ${reps?.length < 2 && 'invisible'}`}>{`Página ${currentPage}`}</div>
              {/* Length End */}
            </Col>
          </Row>
          <Row className="g-0 mb-2 d-none d-lg-flex">
            <Col xs="auto" className={`text-muted mb-3 ${reps?.length < 2 && 'invisible'}`}>
              {`Página ${currentPage}`}
            </Col>
          </Row>
          {/* List Header Start */}
          <BillingRow />
          {/* List Header End */}
          {/* List Items Start */}
          {reps?.map((rep, index) => (
            <BillingCard data={rep} key={index} crmId={crmId} doc="rep" />
          ))}

          {/* List Items End */}
          {/* Pagination Start */}
          <div className={`d-flex flex-column justify-content-center align-items-center mt-5 mx-auto ${totalPages < 2 && 'd-none'}`}>
            <Paginate currentPage={currentPage} totalPages={totalPages} setCurrentPage={setCurrentPage} />
          </div>
          {/* Pagination End */}
        </div>
      )}
    </>
  );
}

export default Reps;
